import { Helmet } from "react-helmet";

export const billFun = (env) => {
  if (env) {
    return (
      <Helmet>
        {" "}
        <link
          href="https://uat.billdesk.com/jssdk/v1/dist/billdesksdk/billdesksdk.css"
          rel="stylesheet"
        />
        <script
          type="module"
          src="https://uat.billdesk.com/jssdk/v1/dist/billdesksdk/billdesksdk.esm.js"
        ></script>
        <script
          nomodule=""
          src="https://uat.billdesk.com/jssdk/v1/dist/billdesksdk.js"
        ></script>
      </Helmet>
    );
  } else {
    return (
      <Helmet>
        {" "}
        <script
          type="module"
          src="https://pay.billdesk.com/jssdk/v1/dist/billdesksdk/billdesksdk.esm.js"
        ></script>
        <script
          nomodule
          src="https://pay.billdesk.com/jssdk/v1/dist/billdesksdk.js"
        ></script>
        <link
          href="https://pay.billdesk.com/jssdk/v1/dist/billdesksdk/billdesksdk.css"
          rel="stylesheet"
        />
      </Helmet>
    );
  }
};
